import { render } from "./App.vue?vue&type=template&id=0f25b5a8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0f25b5a8&lang=css"

import exportComponent from "D:\\1FE\\7律师\\share\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__